export const AppConstants = {
	australia: 'Australia',
	saudiArabia: 'Saudi Arabia',
	unitedStates: 'United States',
	MinInvestment: 100,
	UnitedArabEmirates: 2,
	SaudiArabiaId: 1,
	UTMSource: 'utm_source',
	UTMMedium: 'utm_medium',
	UTMTerm: 'utm_term',
	UTMCampaign: 'utm_campaign',
	UTMContent: 'utm_content',
	WelcomeBonusEligibility: 48
};
